<div class="custom-spinner d-flex d-flex-column justify-content-center align-items-center vw-100 vh-100">

    <div class="reverse-spinner"></div>
    
</div>